module.exports = __webpack_public_path__ + "img/tarpit.c20c1fd4.jpg";